
<div id="roles-popup" class="common-popup-block-doc pop-overrider">
    <form class="form" role="form" autocomplete="off">
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>
                Roles
                <button *ngIf="!toggleAddBtn" (click)="toggleAddForm()" mat-icon-button>
                    <mat-icon>add</mat-icon>
                </button>
            </h2>
        </div>

        <div class="popoup-content">
            
            <ng-container *ngIf="toggleAddBtn">
                <form [formGroup]="rolesForm">
                    <div class="add-section">
                        <div class="set">
                            <mat-label>Rol</mat-label>
                            <mat-form-field class="example-full-width" appearance="fill">
                                <input matInput formControlName="rol" />
                            </mat-form-field>
                        </div>
                        <div class="set">
                            <mat-label>Abreviación</mat-label>
                            <mat-form-field class="example-full-width" appearance="fill">
                                <input matInput formControlName="abreviacion" />
                            </mat-form-field>
                        </div>
                        <div class="set">
                            <mat-label>Tipo</mat-label>
                            <mat-form-field appearance="fill">
                                <mat-select placeholder="" formControlName="tipo">
                                    <mat-option *ngFor="
                                            let tipo of _viewService.tipoList
                                        " [value]="tipo.value">
                                        {{ tipo.viewValue }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="set">
                            <button *ngIf="toggleAddBtn" (click)="addNewRole()" mat-icon-button>
                                <mat-icon>done</mat-icon>
                            </button>
                            <button *ngIf="toggleAddBtn" (click)="toggleAddForm()" mat-icon-button>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </ng-container>
            
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8"  *ngIf="!isLoading">
                <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->
                <!-- Position Column -->
                <caption></caption>
                <ng-container matColumnDef="rol">
                    <th mat-header-cell *matHeaderCellDef>Rol</th>

                    <td mat-cell *matCellDef="let role">
                        <mat-form-field class="example-full-width" appearance="fill">
                            <input matInput placeholder="Rol" (ngModelChange)="role.rol = $event" [ngModel]="role.rol"
                                [value]="role.rol" [ngModelOptions]="{ standalone: true }" [disabled]="!role.isEdit" />
                        </mat-form-field>
                    </td>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="abreviacion">
                    <th mat-header-cell *matHeaderCellDef>Abreviación</th>
                    <td mat-cell *matCellDef="let role">
                        <mat-form-field class="example-full-width" appearance="fill">
                            <input matInput placeholder="Abreviación" (ngModelChange)="role.abreviacion = $event"
                                [ngModel]="role.abreviacion" [value]="role.abreviacion"
                                [ngModelOptions]="{ standalone: true }" [disabled]="!role.isEdit" />
                        </mat-form-field>
                    </td>
                </ng-container>
                <!-- Weight Column -->
                <ng-container matColumnDef="tipo">
                    <th mat-header-cell *matHeaderCellDef>Tipo</th>
                    <td mat-cell *matCellDef="let role">
                        <mat-form-field appearance="fill">
                            <mat-select placeholder="" (ngModelChange)="role.tipo = $event" [ngModel]="role.tipo"
                                [value]="role.tipo" [ngModelOptions]="{ standalone: true }" [disabled]="!role.isEdit">
                                <mat-option *ngFor="let tipo of _viewService.tipoList" [value]="tipo.value">
                                    {{ tipo.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </td>
                </ng-container>
                <!-- Symbol Column -->
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let role">
                        <button mat-icon-button *ngIf="!toggleUpdateBtn">
                            <mat-icon (click)="toggleUpdate(role)">edit</mat-icon>
                        </button>

                        <button mat-icon-button *ngIf="toggleUpdateBtn && role.isEdit">
                            <mat-icon (click)="updateRole(role)">done</mat-icon>
                        </button>

                        <button mat-icon-button *ngIf="toggleUpdateBtn && role.isEdit">
                            <mat-icon (click)="cancelUpdate()">cancel</mat-icon>
                        </button>

                        <button mat-icon-button>
                            <mat-icon (click)="deleteRole(role)">delete_forever</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <div *ngIf="isLoading" class="m-auto">
                <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                </mat-progress-spinner>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="cancel" (click)="cancel()">
                <span class="mat-button-wrapper">Cancelar</span>
            </button>
        </div>
    </form>
</div>